import { render, staticRenderFns } from "./scratchwork.vue?vue&type=template&id=0e35d546&scoped=true&"
import script from "./scratchwork.vue?vue&type=script&lang=js&"
export * from "./scratchwork.vue?vue&type=script&lang=js&"
import style0 from "./scratchwork.vue?vue&type=style&index=0&id=0e35d546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e35d546",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e35d546')) {
      api.createRecord('0e35d546', component.options)
    } else {
      api.reload('0e35d546', component.options)
    }
    module.hot.accept("./scratchwork.vue?vue&type=template&id=0e35d546&scoped=true&", function () {
      api.rerender('0e35d546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scratchwork/scratchwork.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/scratchwork/scratchwork.vue
// module id = byNG
// module chunks = 0